<template>
  <div style="margin: 0px 30px" class="report-15 report-fs" dir="rtl">
    <div style="margin-top: 200px" v-if="pathLogo == m"></div>

    <div class="mlogo">
      <img class="wlogo" :src="pathLogo" />
    </div>

    <h3 class="text-center fs-head-co">{{ fullName }}</h3>
    <h3 class="text-center fs-head-co">{{ shortName }}</h3>

    <h3 style="font-weight: bold" class="text-center fs-head">بطاقة الموظف</h3>

    <section class="header">
      <h5 style="padding-top: 85px" class="text-right">
        التاريخ : {{ convert(new Date()) }}
      </h5>

      <div
        v-if="personalPicture == true"
        style="width: 130px; margin-bottom: 5px"
        class="mlogo t-alignlogo"
      >
        <img class="wlogo" :src="allData.personalPicture" />
      </div>

      <div v-else class="left">
        <div class="img-container" style="height: 150px; width: 140px">
          <p style="font-size: 19px !important">صورة الموظف</p>
        </div>
      </div>
    </section>
    <section class="body">
      <div style="margin-top: 50px" class="first-section">
        <div class="right">
          <div class="t-head">
            <p>البيانات الشخصية :</p>
            <span class="mr-13"></span>
          </div>
          <div class="t-body">
            <p>
              الاسم :<span class="mr-13">{{ allData.employeeName }}</span>
            </p>
            <p>
              رقم الملف الشخصي :
              <span class="mr-13">{{ allData.profileNumber }}</span>
            </p>
            <p>
              الرقم الوطني :
              <span class="mr-13">{{ allData.nationalNumber }}</span>
            </p>
          </div>

          <div class="t-body">
            <p>
              الجنس : <span class="mr-13">{{ allData.gender }}</span>
            </p>
            <p>
              تاريخ الميلاد :
              <span class="mr-13">{{ convert(allData.birthDate) }}</span>
            </p>
            <p>
              رقم الهاتف : <span class="mr-13">{{ allData.phone }}</span>
            </p>
          </div>

          <div class="t-body">
            <p>
              العنوان : <span class="mr-13">{{ allData.address }}</span>
            </p>
            <p>
              الحالة الاجتماعية :
              <span class="mr-13">{{ allData.socialStatus }}</span>
            </p>
            <p>
              البريد الإلكتروني : <span class="mr-13">{{ allData.email }}</span>
            </p>
          </div>

          <div class="t-body">
            <p>
              المؤهل العلمي :
              <span class="mr-13">{{ allData.scientificAppointment }}</span>
            </p>
            <p>
              التخصص : <span class="mr-13">{{ allData.specialization }}</span>
            </p>
            <p></p>
          </div>
        </div>
      </div>

      <div style="margin-top: 50px" class="first-section">
        <div class="right">
          <div class="t-head">
            <p>البيانات الوظيفية :</p>
          </div>
          <div class="t-body">
            <p>
              الادارة / المكتب :
              <span class="mr-13">{{ allData.departmentName }}</span>
            </p>
            <p>
              القسم / المشروع :
              <span class="mr-13">{{ allData.sectionName }}</span>
            </p>
            <p>
              الوحدة : <span class="mr-13">{{ allData.unitName }}</span>
            </p>
          </div>

          <div class="t-body">
            <p>
              نوع التوظيف : <span class="mr-13">{{ allData.jobType }}</span>
            </p>
            <p>
              الصفة الوظيفية :
              <span class="mr-13">{{ allData.jobDescription }}</span>
            </p>
            <p>
              تاريخ المباشرة :
              <span class="mr-13">{{ convert(allData.jobDate) }}</span>
            </p>
          </div>

          <div v-if="allData.jobType != 'عقد'" class="t-body">
            <p>
              الدرجة : <span class="mr-13">{{ allData.currentGrade }}</span>
            </p>
            <p>
              العلاوة : <span class="mr-13">{{ allData.currentBonus }}</span>
            </p>
            <p>
              تاريخ الحصول على الدرجة :
              <span class="mr-13">{{ convert(allData.lastGradeUpdate) }}</span>
            </p>
          </div>

          <div class="t-body">
            <p v-if="allData.jobType != 'عقد'">
              تاريخ استحقاق الترقية :
              <span class="mr-13">{{
                convertYear(allData.upgradeDueDate)
              }}</span>
            </p>
            <p v-if="allData.jobType != 'عقد'">
              شهر استحقاق العلاوة :
              <span class="mr-13">{{ allData.monthName }}</span>
            </p>
            <p>
              رصيد الإجازات السنوي :
              <span class="mr-13">{{ allData.balanceDays }}</span>
            </p>
          </div>
        </div>
      </div>

      <div style="margin-top: 50px" class="first-section">
        <div class="right">
          <div class="t-head">
            <p>البيانات المالية:</p>
          </div>
          <div class="t-body">
            <p>
              رقم الملف المالي :
              <span class="mr-13">{{ allData.fileNumber }}</span>
            </p>
            <p>
              المرتب الأساسي :
              <span class="mr-13">{{ allData.basicSalary }}</span>
            </p>
            <p>
              رقم الضمان :
              <span class="mr-13">{{ allData.securityNumber }}</span>
            </p>
          </div>

          <div class="t-body">
            <p>
              المصرف : <span class="mr-13">{{ allData.bankBranchName }}</span>
            </p>
            <p>
              رقم الحساب :
              <span class="mr-13">{{ allData.accountNumber }}</span>
            </p>
            <p></p>
          </div>
        </div>
      </div>

      <div style="margin-top: 50px" class="first-section">
        <div class="right">
          <div class="t-head">
            <p style="text-align: center">تقييم الكفاءة لآخر ثلاث سنوات:</p>
          </div>
          <div style="text-align: center" class="t-body">
            <p>السنة</p>
            <p style="width: 60%">التقييم</p>
          </div>

          <div style="text-align: center" class="t-body">
            <p>{{ allData.numberOfTheYear }}</p>
            <p style="width: 60%">{{ allData.efficiency }}</p>
          </div>
          <div style="text-align: center" class="t-body">
            <p>{{ allData.numberOfTheYearTwo }}</p>
            <p style="width: 60%">{{ allData.efficiencyTwo }}</p>
          </div>
          <div style="text-align: center" class="t-body">
            <p>{{ allData.numberOfTheYearThree }}</p>
            <p style="width: 60%">{{ allData.efficiencyThree }}</p>
          </div>
        </div>
      </div>
    </section>

    <div class="md-layout mt-25 text-center last-footer">
      <div class="md-layout-item md-size-50">
        <p style="font-weight: bold; margin-bottom: 50px">
          إعداد قسم شؤون الموظفين
        </p>
        <p>--------------------------</p>
      </div>

      <div class="md-layout-item md-size-50">
        <p style="font-weight: bold; margin-bottom: 50px">
          اعتماد مدير إدارة الشؤون الإدارية
        </p>
        <p>--------------------------</p>
      </div>
    </div>
  </div>
</template>

<script>
import env from "../../../env";

export default {
  props: [
    "allData",
    "month",
    "Date",
    "fullName",
    "shortName",
    "pathLogo",
    "personalPicture",
  ],
  data() {
    return {
      m: env.mTop(),
    };
  },

  methods: {
    convertYear(event) {
      try {
        let d = new Date(event);
        if (isNaN(d.getFullYear()) === true) {
          return " - ";
        }
        return (
          d.getFullYear() + " - " + (d.getMonth() + 1)

          // +
          // " , "
          // +
          // d.getHours() +
          // ":" +
          // d.getMinutes()
        );
      } catch (error) {}
    },
    convert(event) {
      try {
        let d = new Date(event);
        if (isNaN(d.getFullYear()) === true) {
          return " - ";
        }
        return (
          d.getFullYear() + " - " + (d.getMonth() + 1) + " - " + d.getDate()

          // +
          // " , "
          // +
          // d.getHours() +
          // ":" +
          // d.getMinutes()
        );
      } catch (error) {}
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/employeeCard";

.img-container {
  border-radius: 3px;
  display: flex;
  justify-content: center;
  align-items: center;

  p {
    height: fit-content;
  }
}

.report-fs {
  * {
    font-size: 22px !important;
    font-family: "Cairo", sans-serif !important;
  }

  .fs-head-co {
    font-size: 29px !important;
    font-weight: bold;
  }

  .fs-head {
    font-size: 25px !important;
  }
}
</style>
